import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { fvFormatClock, fvFormatSince } from '@fv/ui-kit/utils/format-time';

import { STATUS_PAGE_LOCALE } from '../../constants/status-page.constants';
import { SYSTEM_HEALTH_COPY } from '../../constants/system-health.copy';
import { SystemStatusPageQaKeys } from '../../qa-keys';
import { DisplayState } from '../../types/display-state.enum';
import { AffectedServiceView } from '../../types/system-health.types';
import { interpolate } from '../../utils/interpolate';
import { StatusPillComponent } from '../status-pill/status-pill.component';

@Component({
  selector: 'fv-status-card',
  standalone: true,
  imports: [StatusPillComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './status-card.component.html',
  styleUrl: './status-card.component.scss',
})
export class StatusCardComponent {
  readonly qaKeys = SystemStatusPageQaKeys;

  readonly label = input.required<string>();
  readonly state = input.required<DisplayState>();
  readonly affectedServices = input<AffectedServiceView[]>([]);
  readonly lastCheckedAt = input(0);
  readonly sinceAt = input(0);
  readonly error = input('');
  /** The page clock, so "unavailable since 23:50" stops reading as tonight once the day flips. */
  readonly now = input.required<number>();

  readonly copy = SYSTEM_HEALTH_COPY.labels;

  readonly lastChecked = computed(
    () => fvFormatClock(this.lastCheckedAt(), STATUS_PAGE_LOCALE) || this.copy.neverChecked
  );
  readonly since = computed(() => fvFormatSince(this.sinceAt(), STATUS_PAGE_LOCALE, this.now()));
  readonly sinceLabel = computed(() => interpolate(this.copy.unavailableSince, { time: this.since() }));
  readonly isUnavailable = computed(() => this.state() === DisplayState.Unavailable);
  readonly serviceChips = computed(() =>
    this.affectedServices().map(service => ({
      name: service.name,
      state: service.state,
      accessibleName: interpolate(this.copy.serviceState, {
        service: service.name,
        state: SYSTEM_HEALTH_COPY.states[service.state],
      }),
    }))
  );
}
